import { AnchorHTMLAttributes, ReactNode } from 'react'
import { Link, LinkProps } from 'react-router-dom'

type AppLinkProps = LinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
    children: ReactNode
  }

export default function AppLink({ children, ...props }: AppLinkProps) {
  return <Link {...props}>{children}</Link>
}
